import React from "react";
import { PageHeader } from "../components/PageHeader";
import { Testimonials } from "../components/Testimonials";
import { useLang } from "../context/LanguageContext";

export default function Reviews() {
  const { t } = useLang();
  return (
    <div className="bg-white" data-testid="reviews-page">
      <PageHeader label={t.reviews.overline} title={t.pages.reviewsTitle} subtitle={t.pages.reviewsSub} />
      <Testimonials />
    </div>
  );
}
